import { IconCheck, IconCopy, IconEdit, IconEye, IconTrash, IconSearch } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import ModalItemPindah from './ModalItemPindah';

export default function DefaultItem({
  items,
  getItemEdit,
  handleCheckboxChange,
  showDetailItem,
  startIndex,
  selectedItems = [],
  getIdDelete,
  cabang,
  showUkuran = false,
  hideDetail = false,
  hideEdit = false,
  tdPadding = 'px-2 py-1.5',
}) {
  const userRole = localStorage.getItem('role');
  const shouldHideDetail = hideDetail || userRole === 'operator_rumah';
  const shouldHideEdit = hideEdit || userRole === 'operator_rumah';
  const isDeleteDisabled = selectedItems && selectedItems.length > 1;
  // console.log(selectedItems)
  const [copyItemId, setCopyItemId] = useState(null);

  const handleCopy = (id, nama) => {
    navigator.clipboard.writeText(nama);
    setCopyItemId(id);
    setTimeout(() => {
      setCopyItemId(null);
    }, 3000);
  };

  const [isOpenModalPindah, setOpenModalPindah] = useState(false);
  function closeModalPindah() {
    setOpenModalPindah(false);
  }
  
  return (
    <>
      <ModalItemPindah cabang={cabang} isOpenModalPindah={isOpenModalPindah} closeModalPindah={closeModalPindah} />
      {(!items || items.length === 0) ? (
        <tr>
          <td colSpan={showUkuran ? 10 : 9} className="py-20 text-center">
            <div className="flex flex-col items-center justify-center gap-2.5 text-slate-400 dark:text-slate-500">
              <div className="w-12 h-12 rounded-full bg-amber-50 dark:bg-amber-900/20 text-amber-500 flex items-center justify-center border border-amber-200/60 dark:border-amber-800/40">
                <IconSearch size={24} />
              </div>
              <p className="text-sm font-semibold text-slate-700 dark:text-slate-200">
                Tidak ada data barang yang sesuai
              </p>
              <p className="text-xs text-slate-400 dark:text-slate-500 max-w-sm">
                Tidak ditemukan data barang untuk filter yang dipilih. Silakan ubah filter atau gunakan tombol reload.
              </p>
            </div>
          </td>
        </tr>
      ) : (
        items.map((item, index) => (
        <tr
          key={item.id}
          onClick={(e) => {
            e.stopPropagation();
            showDetailItem(item.id);
          }}
          className="bg-white dark:bg-slate-900 text-slate-800 dark:text-slate-200 cursor-pointer border-b border-slate-200 dark:border-slate-800 hover:bg-slate-50 dark:hover:bg-slate-800/60 transition-colors"
        >
          <td className={`${tdPadding} border-r border-slate-200 dark:border-slate-800 whitespace-nowrap font-normal text-slate-500 dark:text-slate-400`}>
            {startIndex + index + 1}.
          </td>
          <td className={`${tdPadding} border-r border-slate-200 dark:border-slate-800 whitespace-nowrap font-normal`}>
            <div className="flex gap-1.5 items-center">
              <span>
                {copyItemId === item.id ? (
                  <IconCheck
                    className="cursor-pointer w-4 h-4 stroke-1 text-emerald-500"
                    onClick={(e) => e.stopPropagation()}
                  />
                ) : (
                  <IconCopy
                    className="cursor-pointer w-4 h-4 stroke-1 text-slate-400 hover:text-amber-500 transition-colors"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCopy(item.id, item.kode_item);
                    }}
                  />
                )}
              </span>
              {item.is_ready === true ? (
                <span className="font-semibold text-slate-900 dark:text-slate-100">{item.kode_item}</span>
              ) : (
                <span className="line-through text-slate-400 dark:text-slate-500">{item.kode_item}</span>
              )}
            </div>
          </td>
          <td className={`${tdPadding} border-r border-slate-200 dark:border-slate-800 whitespace-nowrap font-normal`}>
            {item.jenis_kategori?.nama_jenis}
          </td>
          <td className={`${tdPadding} border-r border-slate-200 dark:border-slate-800 whitespace-nowrap font-normal`}>
            {item.nomor_rak}
          </td>
          <td className={`${tdPadding} border-r border-slate-200 dark:border-slate-800 whitespace-nowrap font-normal`}>
            {item.berat} gr | {item.karat} krt
          </td>
          {showUkuran && (
            <td className={`${tdPadding} border-r border-slate-200 dark:border-slate-800 whitespace-nowrap font-normal`}>
              {item.ukuran || '-'}
            </td>
          )}
          <td className={`${tdPadding} border-r border-slate-200 dark:border-slate-800 whitespace-nowrap font-normal text-slate-600 dark:text-slate-400`}>
            {item.cabang?.nama_cabang}
          </td>
          <td className={`${tdPadding} border-r border-slate-200 dark:border-slate-800 whitespace-nowrap font-normal text-slate-500 dark:text-slate-400`}>
            {item.created_at}
          </td>
          <td className={`${tdPadding} border-r border-slate-200 dark:border-slate-800 whitespace-nowrap`}>
            <div className="flex gap-1.5 items-center justify-center">
              {!shouldHideDetail && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    showDetailItem(item.id);
                  }}
                  className="p-1.5 rounded flex items-center justify-center bg-emerald-500 hover:bg-emerald-600 text-white transition duration-200 shadow-sm"
                  title="Lihat Detail"
                >
                  <IconEye size={15} />
                </button>
              )}
              {!shouldHideEdit && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    getItemEdit(item.id);
                  }}
                  className="p-1.5 rounded flex items-center justify-center bg-amber-500 hover:bg-amber-600 text-white transition duration-200 shadow-sm"
                  title="Edit Item"
                >
                  <IconEdit size={15} />
                </button>
              )}

              <button
                disabled={isDeleteDisabled}
                onClick={(e) => {
                  e.stopPropagation();
                  if (isDeleteDisabled) return;
                  getIdDelete(item.id);
                }}
                className={`p-1.5 rounded flex items-center justify-center transition duration-200 shadow-sm ${
                  isDeleteDisabled
                    ? 'bg-slate-200 dark:bg-slate-700 text-slate-400 dark:text-slate-500 cursor-not-allowed shadow-none'
                    : 'bg-rose-500 hover:bg-rose-600 text-white cursor-pointer'
                }`}
                title={isDeleteDisabled ? 'Pilih tombol Hapus Banyak di atas jika memilih lebih dari 1 item' : 'Hapus Item'}
              >
                <IconTrash size={15} />
              </button>
            </div>
          </td>
          <td className={`${tdPadding} text-center whitespace-nowrap font-normal`}>
            <div className="flex items-center justify-center">
              <input
                checked={selectedItems.some((si) => si.id === item.id)}
                onChange={(event) => handleCheckboxChange(event, item)}
                onClick={(e) => e.stopPropagation()}
                type="checkbox"
                className="cursor-pointer checkbox checkbox-warning w-[18px] h-[18px] border-slate-400 dark:border-slate-500 rounded transition-all"
              />
            </div>
          </td>
        </tr>
      )))}
    </>
  );
}
